import MotivoCancelamentoNovo from './MotivoCancelamentoNovo';

export default MotivoCancelamentoNovo;